import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";

import DatePicker from "react-datepicker";

import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout, zeroFill } from "common/SharedFn";
import { getAllShifts, addShift, enableShift, disableShift } from "../../network/ApiAxios";
import {  Check,Block} from "@material-ui/icons";
import { ArrowBack } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DriverShiftsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const { parseISO } = require("date-fns");
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  // const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [shiftName, setShiftName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const startDate = startTime ? parseISO(`1970-01-01T${startTime}`) : null;
  const endDate = endTime ? parseISO(`1970-01-01T${endTime}`) : null;


  const [isEnabled, setisEnabled] = useState(1);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  let history = useHistory();
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id,shiftName,startTime,endTime,isEnabled} = info;
    setShiftName(shiftName);
    setStartTime(startTime);
    setEndTime(endTime);
    setisEnabled(isEnabled);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setShiftName("");
    setStartTime("");
    setEndTime("");
    setisEnabled(1);
    setId();
  };

  const fetchShifts = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllShifts();  
    const { data } = response;
    // const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      // setCountries(responseCountries.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch shifts");
    }
    setIsLoading(false);
  };



  const addShiftAction = async () => {
    setIsLoading(true);
    try{
      console.log("addShiftAction");
      console.log(shiftName);
      console.log(startTime);
      console.log(endTime);
      console.log(isEnabled);
    const response = await addShift(shiftName, startTime, endTime, isEnabled);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Shift Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add shift");
      setIsLoading(false);
    }
  };


  const enableShiftAction = async () => {
    setIsLoading(true);
    try{
    const response = await enableShift(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Shift Enabled Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to enable shift");
      setIsLoading(false);
    }
  };

  const disableShiftAction = async () => {
    setIsLoading(true);
    try{
    const response = await disableShift(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Shift Disabled Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to disable shift");
      setIsLoading(false);
    }
  };


  useAsyncEffect(async () => {
    if(executeUpdate){
      if(isEnabled == 1){
        await enableShiftAction();
      }
      else{
        await disableShiftAction();
      }
      setExecuteUpdate(false);
    }
    else{
      fetchShifts();
    }
  }, [executeUpdate,forceRefresh]);

  const makeTableRow = (info) => {
    if(info.isEnabled == 0){
      info.isEnabledText = "No";
    }
    else{
      info.isEnabledText = "Yes";
    }
    // for (var i=0; i < countries.length; i++) {
    //   if(countries[i].id == info.countryId){
    //     info.countryText = countries[i].nameEn;
    //     break;
    //   }
    // }
    return {
      ...info,
      idForm: (
        "D"+zeroFill(info.id,5)
      ),
      actions: (
        <div className="actions-right">
          {/* <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip> */}
          
          <div style={{ display: "inline-block" }}>
            {info.isEnabled == 1 ? (
              <Tooltip title="Disable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedInfo,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Disable Shift","Are you sure you would like to disable the shift "+info.shiftName+"?",async () =>  {
                    setCurrentRecord(info);
                    setisEnabled(Math.abs(info.isEnabled-1));
                    setAlert(null);
                    setExecuteUpdate(true);                   
                  })}}
                >
                  <Box component={Block} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Enable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Enable Shift","Are you sure you would like to enable the shift "+info.shiftName+"?",async () => {
                    setCurrentRecord(info);
                    setisEnabled(Math.abs(info.isEnabled-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                  })}}
                >
                  <Box component={Check} />
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shiftName",
                    text: "Name English",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "startTime",
                    text: "Start Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "endTime",
                    text: "End Time",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isEnabledText",
                    text: "Enabled",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  // {
                  //   dataField: "countryText",
                  //   text: "Country",
                  //   sort: true,
                  //   style: {'whiteSpace': 'normal'}
                  // },
                  {
                    dataField: "actions",
                    classes: "actions-col",
                    headerClasses: "actions-col",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <>
                  <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Driver Shifts</Box>
                    </Box>
                        </>
                        <Tooltip title="Add new shift">
                          <IconButton
                            size="small"
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                            style={{
                              width: 32, height: 32,
                              backgroundColor: "#fff",
                              border: "1px solid #5e72e4",
                              color: "#5e72e4",
                            }}
                          >
                            <AddIcon style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                        
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                                      </>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Driver
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>

                <FormGroup>
                  <FormLabel>Shift Name (English)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Shift Name (Enghlish)"
                    value={shiftName ?? ""}
                    onChange={(e) => setShiftName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Start Time</FormLabel>
                  <DatePicker
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Start Time"
                    selected={startDate}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => {
                      const formattedTime = date.toLocaleTimeString('en-US', { hour12: false });
                      setStartTime(formattedTime);
                    }}
                    dateFormat="HH:mm:ss"
                  />
                  {/* <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Start Time"
                    value={startTime ?? ""}
                    onChange={(e) => setStartTime(e.target.value)}
                  /> */}
                </FormGroup>


                <FormGroup>
                  <FormLabel>End Time</FormLabel>
                  <DatePicker
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="End Time"
                    selected={endDate}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => {
                      const formattedTime = date.toLocaleTimeString('en-US', { hour12: false });
                      setEndTime(formattedTime);
                    }}
                    dateFormat="HH:mm:ss"
                  />
                  {/* <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="End Time"
                    value={endTime ?? ""}
                    onChange={(e) => setEndTime(e.target.value)}
                  /> */}
                </FormGroup>
{/* 

                <FormGroup>
                  <FormLabel>Country</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={countryId} onChange={(e) => setCountryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {countries.map(function(country, i){
                        return <MenuItem value={country.id}>{country.nameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup> */}

                <FormGroup>
                  <FormLabel>Enabled</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isEnabled} onChange={(e) => setisEnabled(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={1}>Yes</MenuItem>
                      <MenuItem value={0}>No</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addShiftAction() : null
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default DriverShiftsTable;
